import React from "react";
import { Row, Col, Form, InputNumber, Select, Button, message, Icon, Input, Radio, DatePicker } from "antd";
import PropTypes from "prop-types";
import CompanyLosService from "./services/company-los-services";
import { GenericToolTip } from "../../components/genericTooltip";
import { ADD_COMMON_FORM } from "./constants/fields_info_json";
import {isAscending, leapYear} from "../../components/helper";
import { SubventionType } from "../../constants/enums";

const InterestType = [
    {
        label: "Flat",
        value: "1"
    },
    {
        label: "Reducing",
        value: "2"
    }
];

var InstalmentFrequency = [
    // {
    //     label: "Daily",
    //     unit: "Day(s)",
    //     value: "1"
    // },
    // {
    //     label: "Weekly",
    //     unit: "Week(s)",
    //     value: "7"
    // },
    {
        label: "Monthly",
        unit: "Month(s)",
        value: 28
    },
    // {
    //     label: "Yearly",
    //     unit: "Year(s)",
    //     value: "365"
    // },
    {
        label: "Custom",
        value: "custom"
    }
];


// const InstalmentDateCalculation = [
//     {
//         label: "Fixed Date",
//         value: "1"
//     },
//     {
//         label: "Basis Disbursal Date",
//         value: "2"
//     }
// ];

class AddTermLoanSchemeDetail extends React.Component {

    state = {
        normalRoi: null,
        interestType: null,
        // upfrontInterestDeduction: null,
        overdueROI: 36,
        gracePeriodOD: 9999,
        instalmentFrequency: null,
        customFrequency: null,
        minLoanAmount: null,
        maxLoanAmount: null,
        minLoanTenure: null,
        maxLoanTenure: null,
        minLoanTenureUnit: null,
        maxLoanTenureUnit: null,
        instalmentDateCalculation: null,
        gracePeriodfirstInstalmentDate: null,
        fixedEMIDate: null,
        // fixedEMICutOffPeriod: null,
        fixedEMICutOffDate: null,
        maxgracePeriodfirstInstalmentDate: null,
        non_field_error: null,
        loading: false,
        show_api_err: false,
        gracePeriodfirstInstalmentDateErr: false,
        gracePeriodODErr: false,
        error: null,
        normalRoiErr: false,
        overdueROIErr: false,
        // upfrontInterestDeductionErr: false,
        holdBackPercentage: 0,
        holdBackPercentageErr: false,
        minLoanAmountErr: false,
        maxLoanAmountErr: false,
        minLoanTenureErr: false,
        maxLoanTenureErr: false,
        customFrequencyErr: false,
        tenor: null,
        instalmentDateCalculationView: null,
        anchorId: null,
        max_moratorium_period : 0,
        is_moratorium_interest_charged : true,
        is_principal_in_first_instalment_after_moratorium: true,
        // buyer_subvention_days: null,
        // seller_subvention_days : null,
        subvention_program_type: null,
        upfront_interest_percentage : 0.0,
        buyer_subvention_days: 0,
        subvention_sub_program_type: null,
        emiCountInMonth: 0,
        emi_dates : {},
        cutOffDays: 0,
        cutOffDaysErr : false
    }

    onChange(key, value) {
        this.setState({
            non_field_error: null,
            show_api_err: false,
            gracePeriodfirstInstalmentDateErr: false,
            gracePeriodODErr: false,
            normalRoiErr: false,
            // upfrontInterestDeductionErr: false,
            holdBackPercentageErr: false,
            overdueROIErr: false,
            minLoanAmountErr: false,
            maxLoanAmountErr: false,
            minLoanTenureErr: false,
            maxLoanTenureErr: false,
            customFrequencyErr: false,
            error: null,
            upfront_interest_percentage : 0.0,
            subvention_sub_program_type : null,
            buyer_subvention_days: 0
        });
        let getFrequencyLabel = null;

      

        if (key == "instalmentFrequency") {
            if(value != "custom"){
                this.setState({
                    cutOffDays : 0,
                    emiCountInMonth : 0,
                    emi_dates: {}
                })
            }
            getFrequencyLabel = InstalmentFrequency.filter((item) => item.value == value);
        } else {
            getFrequencyLabel = InstalmentFrequency.filter((item) => item.value == this.state.instalmentFrequency);
        }
        if (key == "normalRoi") {
            if (this.props.anchorList?.length == 1) {
                this.setState({
                    anchorId: this.props.anchorList[0].id
                });
            }
            if (value < 0 || value > 60) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    normalRoiErr: true
                });
            } else {
                this.setState({
                    [key]: value,
                    // overdueROI: null
                });
            }
        }
        // else if (key == "upfrontInterestDeduction") {
        //     if (value < 0 || value > 60) {
        //         this.setState({
        //             error: "Value can't be less than 0 or greater than 100",
        //             upfrontInterestDeductionErr: true
        //         });
        //     } else {
        //         this.setState({
        //             [key]: value
        //         });
        //     }
        // }

        else if (key == "holdBackPercentage") {
            if (value < 0 || value > 100) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    holdBackPercentageErr: true
                });
            } else {
                this.setState({
                    [key]: value
                });
            }
        }

        else if (key == "overdueROI") {
            if (value < 1 || value > 60) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    overdueROIErr: true
                });
            } else if (value < this.state.normalRoi || value == this.state.normalRoi) {
                this.setState({
                    error: "Value can't be less than or equal to normal roi",
                    overdueROIErr: true
                });
            } else {
                this.setState({
                    [key]: value
                });
            }
        }
        else if (key == "instalmentFrequency") {
            this.setState({
                [key]: value,
                customFrequency: null,
                minLoanTenure: null,
                maxLoanTenure: null,
                gracePeriodfirstInstalmentDate: null,
                minLoanTenureUnit: null,
                maxLoanTenureUnit: null,
                maxgracePeriodfirstInstalmentDate: null,
                tenor: null
            });
            if (value == 28) {
                this.setState({ instalmentDateCalculation: 1, instalmentDateCalculationView: "Fixed Date", gracePeriodfirstInstalmentDate: null });
            } else {
                this.setState({ instalmentDateCalculation: 1, instalmentDateCalculationView: "Fixed Date", fixedEMICutOffDate: null, fixedEMIDate: null });
            }
        } else if (key == "gracePeriodOD") {
            if (value < 0 || value > 9999) {
                this.setState({
                    error: "Please enter valid input",
                    gracePeriodODErr: true
                });
            } else {
                this.setState({
                    [key]: value
                });
            }
        }
        else if (key == "customFrequency") {
            if (value < 1 || value > 365) {
                this.setState({
                    error: "Please enter valid input",
                    customFrequencyErr: true
                });
            } else if (value == 1) {
                this.setState({
                    error: "Please select instalment frequency Daily",
                    customFrequencyErr: true
                });
            } else {
                this.setState({
                    [key]: value
                });
            }
        }
        else if (key == "minLoanAmount") {
            if (value < 1) {
                this.setState({
                    error: "Please enter valid input",
                    minLoanAmountErr: true
                });
            } else {
                this.setState({
                    [key]: value,
                    maxLoanAmount: null
                });
            }
        }
        else if (key == "maxLoanAmount") {
            if (value < 1 || value > 100000000) {
                this.setState({
                    error: "Please enter valid input",
                    maxLoanAmountErr: true
                });
            } else if (value < this.state.minLoanAmount || value == this.state.minLoanAmount) {
                this.setState({
                    error: "Value can't be less than min loan amount",
                    maxLoanAmountErr: true
                });
            } else {
                this.setState({
                    [key]: value
                });
            }
        }
        else if (key == "minLoanTenure") {
            if (value < 1 || value > 9999) {
                this.setState({
                    error: "Please enter valid input",
                    minLoanTenureErr: true
                });
            } else {
                this.setState({
                    [key]: value,
                    minLoanTenureUnit: this.state.instalmentFrequency == "custom" ? value * this.state.customFrequency : getFrequencyLabel[0]?.unit,
                    maxLoanTenure: null,
                    maxLoanTenureUnit: null,
                    tenor: null
                });
            }
        } else if (key == "maxLoanTenure") {
            if (value < 1 || value > 9999) {
                this.setState({
                    error: "Please enter valid input",
                    maxLoanTenureErr: true
                });
            } else if (value < this.state.minLoanTenure || value == this.state.minLoanTenure) {
                this.setState({
                    error: "Value can't be less than min loan tenure",
                    maxLoanTenureErr: true
                });
            } else {
                this.setState({
                    [key]: value,
                    tenor: this.state.instalmentFrequency == "custom" ? value * this.state.customFrequency : value * this.state.instalmentFrequency,
                    maxLoanTenureUnit: this.state.instalmentFrequency == "custom" ? value * this.state.customFrequency : getFrequencyLabel[0]?.unit
                });
            }
        } else if (key == "instalmentDateCalculation") {
            if (value == 1) {
                this.setState({
                    [key]: value,
                    gracePeriodfirstInstalmentDate: null
                });
            } else {
                this.setState({
                    [key]: value,
                    fixedEMICutOffDate: null,
                    fixedEMIDate: null
                });
            }
        } else if (key == "gracePeriodfirstInstalmentDate") {
            if (value < 1 || value > 6) {
                this.setState({
                    error: "Please enter valid input",
                    gracePeriodfirstInstalmentDateErr: true
                });
            } else {
                this.setState({
                    [key]: value,
                    maxgracePeriodfirstInstalmentDate: this.state.instalmentFrequency == "custom" ? value * this.state.customFrequency : getFrequencyLabel[0]?.unit
                });
            }
        }else if (key == "subvention_sub_program_type"){
            this.setState({
                upfront_interest_percentage: 0.0,
                buyer_subvention_days : 0,
                [key]: value
            })
        }else if(key == 'interestType'){
            this.setState({
                [key]: value
            });
        }else {
            this.setState({
                [key]: value
            });
        }
    }

    onSchemeAddClick = () => {
        const {
            normalRoi,
            interestType,
            // upfrontInterestDeduction,
            overdueROI,
            gracePeriodOD,
            instalmentFrequency,
            customFrequency,
            minLoanAmount,
            maxLoanAmount,
            minLoanTenure,
            maxLoanTenure,
            // minLoanTenureUnit,
            // maxLoanTenureUnit,
            instalmentDateCalculation,
            gracePeriodfirstInstalmentDate,
            fixedEMIDate,
            fixedEMICutOffDate,
            holdBackPercentage
            // tenor
        } = this.state;

        let submitData = {
            "lending_partner": null,
            "margin": this.state.holdBackPercentage || 0,
            "tenor": 9999,
            "overdue_tenor": 9999,
            "min_normal_roi": normalRoi,
            "max_overdue_roi": overdueROI,
            "min_normal_roi_buyer": null,
            "min_normal_roi_seller": null,
            "is_roi_structure_flat": true,
            "roi_schedule": [
                {
                    "from_days": 1,
                    "to_days": 9999,
                    "roi": overdueROI
                }
            ],
            "stop_billing_days": 9999,
            "cooling_period": 0,
            "cashback_sharing_percentage_for_dealer": null,
            "cashback_sharing_percentage_for_seller": null,
            "cashback_sharing_percentage_for_progcap": null,
            "disbursal_wait_days": 0,
            "subvention_perc": 0,
            "subvention_days": 0,
            "is_default_scheme": this.props.isDefaultScheme,
            "scheme_type": "4",
            "instalment_frequency": instalmentFrequency == 28 ? 2 : 1,
            "day_set": instalmentFrequency == 28 ? null : instalmentFrequency == "custom" ? customFrequency : instalmentFrequency,
            "interest_type": parseInt(interestType),
            "loan_amount_min": minLoanAmount,
            "loan_amount_max": maxLoanAmount,
            "min_instalment_count": minLoanTenure,
            "max_instalment_count": maxLoanTenure,
            "upfront_interest_percentage": this.state.upfront_interest_percentage || 0.0,
            "instalment_date_type": parseInt(instalmentDateCalculation),
            "grace_day_set_count": gracePeriodfirstInstalmentDate,
            "fixed_emi_date": fixedEMIDate,
            "fixed_emi_cut_off_date": fixedEMICutOffDate,
            "grace_period_od_interest": gracePeriodOD,
            "progcap_subvention_days": 0,
            "anchor_id": this.state.anchorId,

            "max_moratorium_period" : this.state.max_moratorium_period,
            "is_moratorium_interest_charged": this.state.is_moratorium_interest_charged,
            "is_principal_in_first_instalment_after_moratorium": this.state.is_principal_in_first_instalment_after_moratorium,
            "subvention_program_type" : this.state.subvention_program_type,
            "subvention_sub_program_type": this.state.subvention_sub_program_type,
            "buyer_subvention_days": this.state.buyer_subvention_days == 0 && this.state.subvention_program_type == 1 && this.state.subvention_sub_program_type == 1 ? null :  (this.state.buyer_subvention_days || 0),
            "seller_subvention_days": 0.0,
            "cut_off_days" : this.state.instalmentFrequency == 28 ? undefined :  this.state.cutOffDays,
            "total_no_emi_in_a_month": this.state.instalmentFrequency == 28 ? undefined : this.state.emiCountInMonth,
            "custom_day_set": this.state.instalmentFrequency == 28 ? undefined : Object.values(this.state.emi_dates)

        };
        this.setState({
            loading: true
        });
        CompanyLosService.createNewScheme(this.props.companyId, submitData).then(({ data }) => {
            this.setState({
                loading: false
            });
            message.success("Scheme Created Successfully");
            this.props.onSuccess();
        }).catch((err) => {
            this.setState({
                loading: false,
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)] && err[Object.keys(err)][0] || "Please enter correct data",
            });
        });
    }

    checkSubmit = () => {
        const {
            normalRoiErr,
            overdueROIErr,
            // upfrontInterestDeductionErr,
            holdBackPercentageErr,
            minLoanAmountErr,
            maxLoanAmountErr,
            minLoanTenureErr,
            maxLoanTenureErr,
            gracePeriodfirstInstalmentDateErr,
            max_moratorium_period,
            is_moratorium_interest_charged,
            is_principal_in_first_instalment_after_moratorium,
            subvention_program_type,
            subvention_sub_program_type,
            upfront_interest_percentage,
            buyer_subvention_days,
            instalmentFrequency
            // seller_subvention_days
        } = this.state;
        let subvention_sub_program = {}
        if(subvention_sub_program_type){
            subvention_sub_program = SubventionType.find(_ => _.value == subvention_sub_program_type);
        }
        if (normalRoiErr ||
            overdueROIErr ||
            // upfrontInterestDeductionErr ||
            holdBackPercentageErr || 
            minLoanAmountErr ||
            maxLoanAmountErr ||
            minLoanTenureErr ||
            maxLoanTenureErr ||
            gracePeriodfirstInstalmentDateErr ||  
            is_moratorium_interest_charged == null ||
            is_principal_in_first_instalment_after_moratorium == null || 
            subvention_program_type == null || ( subvention_program_type == 2 && subvention_sub_program_type == null)||
            subvention_program_type == 1 && (upfront_interest_percentage == 0)||
            (this.state.instalmentFrequency == 'custom'  && (Object.values(this.state.emi_dates).length != new Set(Object.values(this.state.emi_dates)).size || !isAscending(Object.values(this.state.emi_dates))) )


            || (this.state.subvention_program_type == 1 && this.state.subvention_sub_program_type == 2 && this.state.interestType != 2)
        ) {
            return true;
        } else {
            return false;
        }
    }
    focusOutEvent = (errState, fieldName) => {
        if (fieldName == "minLoanTenure") {
            if (this.state[errState]) {
                this.setState({
                    [errState]: false,
                    [fieldName]: null,
                    minLoanTenureUnit: null,
                    maxLoanTenureUnit: null
                });
            }
        } else if (fieldName == "maxLoanTenure") {
            if (this.state[errState]) {
                this.setState({
                    [errState]: false,
                    [fieldName]: null,
                    maxLoanTenureUnit: null
                });
            }
        } else {
            if (this.state[errState]) {
                this.setState({
                    [errState]: false,
                    [fieldName]: null
                });
            }
        }
    }

    onChangeEmiCount = (val) => {
        const newEmiDates = {}
        this.setState({
            emiCountInMonth: val <= 28 ? val : 28,
            emi_dates : {}
        } , () => {
            for (let i = 1; i <= this.state.emiCountInMonth; i++) {
                newEmiDates[`emi_date_${i}`] = "";
              }
            this.setState({
                emi_dates : newEmiDates
            })
        })
    }
    render() {
        return (
            <Row gutter={24}>
                <Col>
                    <Form>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col>
                                <Form.Item label={<span>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /></span>} required={true} style={{ margin: "0" }}>
                                    {
                                        this.props.anchorList && this.props.anchorList.length == 1 ? <InputNumber style={{ width: "30%" }} value={this.props.anchorList[0].short_name} disabled={true} /> : <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select Anchor"
                                            optionFilterProp="children"
                                            onChange={(val) => this.setState({ anchorId: val })}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.anchorList && this.props.anchorList.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.id} key={k}>{item.short_name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>Normal ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("tl_normal_roi")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("normalRoiErr", "normalRoi")} value={this.state.normalRoi} style={{ width: "90%" }} onChange={(val) => this.onChange("normalRoi", val)} />
                                </Form.Item>
                                {this.state.normalRoiErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Interest Type<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("interest_type")} /></span>} required={true} style={{ margin: "0" }}>
                                    <Select
                                        style={{ width: 200 }}
                                        placeholder="Select Interest Type"
                                        optionFilterProp="children"
                                        onChange={(val) => this.onChange("interestType", val)}
                                    >
                                        {
                                            InterestType.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.value} key={k}>{item.label}</Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                {/* <Form.Item label={<span>Upfront Interest Deduction (%)<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("upfront_interest_deduction")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("upfrontInterestDeductionErr", "upfrontInterestDeduction")} value={this.state.upfrontInterestDeduction} style={{ width: "90%" }} onChange={(val) => this.onChange("upfrontInterestDeduction", val)} />
                                </Form.Item>
                                {this.state.upfrontInterestDeductionErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>} */}

                                <Form.Item label={<span>Margin (%)</span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber
                                        onBlur={() => this.focusOutEvent("holdBackPercentageErr", "holdBackPercentage")}
                                        value={this.state.holdBackPercentage}
                                        style={{ width: "90%" }}
                                        onChange={(val) => this.onChange("holdBackPercentage", val)}
                                    />
                                </Form.Item>
                                {this.state.holdBackPercentageErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}

                            </Col>
                        </Row>
                        <Row>
                            {/* <Col span={7}>
                                <Form.Item label={<span>Overdue ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("tl_overdue_roi")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("overdueROIErr", "overdueROI")} value={this.state.overdueROI} disabled style={{ width: "90%" }} onChange={(val) => this.onChange("overdueROI", val)} />
                                </Form.Item>
                                {this.state.overdueROIErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col> */}
                            <Col span={7}>
                                <Form.Item label={<span>Grace Period for OD Fee<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("grace_period_for_od_interest")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("gracePeriodODErr", "gracePeriodOD")} value={this.state.gracePeriodOD} style={{ width: "90%" }} onChange={(val) => this.onChange("gracePeriodOD", val)} />
                                </Form.Item>
                                {this.state.gracePeriodODErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={7}>
                                <Form.Item label={<span>Instalment Frequency<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("instalment_frequency")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <Select
                                        style={{ width: 200 }}
                                        placeholder="Select Interest Type"
                                        optionFilterProp="children"
                                        onChange={(val) => this.onChange("instalmentFrequency", val)}
                                    >
                                        {
                                            InstalmentFrequency.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.value} key={k}>{item.label}</Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            {/* {
                                this.state.instalmentFrequency == "custom" ? <React.Fragment>
                                    <Col span={7}>
                                        <Form.Item label={<span>Custom Frequency (in Days)<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("custom_frequency")} /> </span>} required={true} style={{ margin: "0" }}>
                                            <InputNumber onBlur={() => this.focusOutEvent("customFrequencyErr", "customFrequency")} value={this.state.customFrequency} style={{ width: "90%" }} onChange={(val) => this.onChange("customFrequency", val)} className={this.state.instalmentFrequency == "custom" ? null : "read-only-input"} readOnly={this.state.instalmentFrequency == "custom" ? false : true} />
                                        </Form.Item>
                                        {this.state.customFrequencyErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                    </Col>
                                    <Col span={7} style={{ width: "100%" }}></Col>
                                </React.Fragment> : null
                            } */}
                            {
                                this.state.instalmentFrequency == "custom" ? <React.Fragment>
                                    <Col span={7}>
                                        <Form.Item label={<span>EMI count in month<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("custom_frequency")} /> </span>} required={true} style={{ margin: "0" }}>
                                            <InputNumber value={this.state.emiCountInMonth} style={{ width: "90%" }} onChange={(val) => this.onChangeEmiCount(val)} className={this.state.instalmentFrequency == "custom" ? null : "read-only-input"} readOnly={this.state.instalmentFrequency == "custom" ? false : true} />
                                        </Form.Item>
                                        {/* {this.state.customFrequencyErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>} */}
                                    </Col>
                                    <Col span={7} style={{ width: "100%" }}></Col>
                                </React.Fragment> : null
                            }
                            <Col span={24}>
                                <Row>{this.state.emiCountInMonth > 0 ?
                                    Array.from({ length: this.state.emiCountInMonth }).map((_, index) => <Col span={4}><Form.Item label={<span>EMI Date {index + 1} <GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("custom_frequency")} /> </span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber style={{ width: "90%" }} value={this.state.emi_dates[`emi_date_${index + 1}`]} onChange={(val) => this.setState((prevState) => ({
                                            emi_dates: {
                                                ...prevState.emi_dates, // Spread the existing emi_dates
                                                [`emi_date_${index + 1}`]: val <= 28 && val >=1 ? val : 0, // Update the specific key
                                            },
                                        }))} className={this.state.instalmentFrequency == "custom" ? null : "read-only-input"} readOnly={this.state.instalmentFrequency == "custom" ? false : true} />
                                    </Form.Item></Col>) : <></>}
                                </Row>
                                {(Object.values(this.state.emi_dates).length != new Set(Object.values(this.state.emi_dates)).size || !isAscending(Object.values(this.state.emi_dates))) && <span style={{ fontSize: "11px", color: "red" }}>The EMI dates should be different and in specific format</span>}

                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Minimum Loan Amount<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("minimum_loan_amount")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("minLoanAmountErr", "minLoanAmount")} value={this.state.minLoanAmount} style={{ width: "90%" }} onChange={(val) => this.onChange("minLoanAmount", val)} />
                                </Form.Item>
                                {this.state.minLoanAmountErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Maximum Loan Amount<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("maximum_loan_amount")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("maxLoanAmountErr", "maxLoanAmount")} value={this.state.maxLoanAmount} style={{ width: "90%" }} onChange={(val) => this.onChange("maxLoanAmount", val)} />
                                </Form.Item>
                                {this.state.maxLoanAmountErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col span={7}>
                                <Form.Item label={<span>Minimum Loan Amount<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("minimum_loan_amount")} /> </span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("minLoanAmountErr", "minLoanAmount")} value={this.state.minLoanAmount} style={{ width: "90%" }} onChange={(val) => this.onChange("minLoanAmount", val)} />
                                </Form.Item>
                                {this.state.minLoanAmountErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Maximum Loan Amount<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }}/>} tooltipText={ADD_COMMON_FORM.get("maximum_loan_amount")} /> </span>} required={true} style={{margin: "0"}}>
                                    <InputNumber onBlur={() => this.focusOutEvent("maxLoanAmountErr", "maxLoanAmount")} value={this.state.maxLoanAmount} style={{ width: "90%" }} onChange={(val) => this.onChange("maxLoanAmount", val)} />
                                </Form.Item>
                                {this.state.maxLoanAmountErr && <span style={{fontSize: "11px", color: "red"}}>{this.state.error}</span>}
                            </Col>
                        </Row> */}
                        <Row>
                            <Col span={7}>
                                <Form.Item label={<span>Minimum Loan Tenure<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("minimum_loan_tenure")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("minLoanTenureErr", "minLoanTenure")} value={this.state.minLoanTenure} style={{ width: "90%" }} onChange={(val) => this.onChange("minLoanTenure", val)} />
                                </Form.Item>
                                {this.state.minLoanTenureErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={3}>
                                <Form.Item label={<span>Unit<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("minimum_loan_tenure")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <p>{this.state.instalmentFrequency == "custom" && this.state.minLoanTenure !== null && this.state.customFrequency !== null ? "* " + this.state.customFrequency + " = " + Math.floor(this.state.customFrequency * this.state.minLoanTenure) + " Day(s)" : this.state.minLoanTenureUnit}</p>
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Maximum Loan Tenure<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("maximum_loan_tenure")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber onBlur={() => this.focusOutEvent("maxLoanTenureErr", "maxLoanTenure")} value={this.state.maxLoanTenure} style={{ width: "90%" }} onChange={(val) => this.onChange("maxLoanTenure", val)} />
                                </Form.Item>
                                {this.state.maxLoanTenureErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={3}>
                                <Form.Item label={<span>Unit<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("maximum_loan_tenure")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <p>{this.state.instalmentFrequency == "custom" && this.state.maxLoanTenure !== null && this.state.customFrequency !== null ? "* " + this.state.customFrequency + " = " + Math.floor(this.state.customFrequency * this.state.maxLoanTenure) + " Day(s)" : this.state.maxLoanTenureUnit}</p>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "20px" }}>
                            <Col span={8}>
                                <Form.Item label={<span>Max Moratorium Period (in days)</span>} required={true} className="w-90 m-0">
                                    <InputNumber 
                                        min = {0}
                                        style={{ width: "90%" }}
                                        defaultValue={0}                                     
                                        onChange={(val) => {
                                            this.setState({
                                                max_moratorium_period: val,
                                                is_principal_in_first_instalment_after_moratorium : val == 0 ? true : null,
                                                is_moratorium_interest_charged : val == 0 ? true : null
                                            });
                                        }} />
                                    
                                </Form.Item>

                            </Col>
                            <Col span={8}>
                                <Form.Item label={<span>Charge Interest During Moratorium</span>} required={true} className="w-90 m-0">
                                    <Radio.Group
                                        disabled={this.state.max_moratorium_period == 0}
                                        value={this.state.is_moratorium_interest_charged}
                                        onChange={(e) => this.setState({
                                            is_moratorium_interest_charged: e.target.value,
                                            is_principal_in_first_instalment_after_moratorium: e.target.value ? null : true
                                        })}>
                                        <Radio.Button value={true}>Yes</Radio.Button>
                                        <Radio.Button value={false}>No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item></Col>

                            <Col span={8}>
                                <Form.Item label={<span>Charge Only Interest in First Instalment</span>} required={true} className="w-90 m-0">
                                    <Radio.Group 
                                        value={this.state.is_principal_in_first_instalment_after_moratorium}
                                        disabled={!this.state.is_moratorium_interest_charged || this.state.max_moratorium_period == 0}
                                        onChange={(e) => this.setState({
                                            is_principal_in_first_instalment_after_moratorium: e.target.value
                                        })}>
                                        <Radio.Button value={false}>Yes</Radio.Button>
                                        <Radio.Button value={true}>No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row style={{ marginTop: "20px" }} span={24}>
                            <h3>Instalment Date</h3>
                            <Col span={7}>
                                <Form.Item label={<span>Instalment Date Calculation<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("instalment_date_calculation")} /> </span>} required={true} style={{ margin: "0" }}>
                                    <Input disabled={true} value={this.state.instalmentDateCalculationView} style={{ width: "90%" }} />
                                </Form.Item>
                            </Col>
                            {
                                this.state.instalmentFrequency == "custom" ? <React.Fragment>
                                    {/* <Col span={9}>
                                        <Form.Item label={<span>Grace Period for first Instalment Date<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("grace_period_fi_date")} /> </span>} required={true} style={{ margin: "0" }}>
                                            <InputNumber onBlur={() => this.focusOutEvent("gracePeriodfirstInstalmentDateErr", "gracePeriodfirstInstalmentDate")} value={this.state.gracePeriodfirstInstalmentDate} style={{ width: "90%" }} onChange={(val) => this.onChange("gracePeriodfirstInstalmentDate", val)} />
                                        </Form.Item>
                                        {this.state.gracePeriodfirstInstalmentDateErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                    </Col> */}
                                    <Col span={9}>
                                        <Form.Item label={<span>Cut off Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("grace_period_fi_date")} /> </span>} required={true} style={{ margin: "0" }}>
                                            <InputNumber onBlur={() => this.focusOutEvent("cutOffDaysErr", "cutOffDays")} value={this.state.cutOffDays} style={{ width: "90%" }} onChange={(val) => this.onChange("cutOffDays", val)} />
                                        </Form.Item>
                                        {this.state.cutOffDaysErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                    </Col>
                                    <Col span={6} style={{ margin: "0 20px" }}>
                                        <Form.Item label={<span>Unit<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("grace_period_fi_date")} /> </span>} required={true} style={{ margin: "0", marginLeft: "50px" }}>
                                            <p>Day(s)</p>
                                        </Form.Item>
                                    </Col>
                                </React.Fragment> : null
                            }
                        </Row>
                        {
                            <>
                            {this.state.instalmentFrequency !== "custom" ? <Row>
                                <Col span={7}>
                                    <Form.Item label={<span>Fixed EMI Date<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("fixed_emi_date")} /> </span>} required={true} style={{ margin: "0" }}>
                                        <Select
                                            style={{ width: 200 }}
                                            placeholder="Select Fixed EMI Date"
                                            optionFilterProp="children"
                                            onChange={(val) => this.onChange("fixedEMIDate", val)}
                                            className={this.state.instalmentDateCalculation == "1" ? null : "read-only-input"}
                                            disabled={this.state.instalmentDateCalculation == "1" ? false : true}
                                        >
                                            {
                                                Array.from({ length: 28 }, (_, i) => i + 1).map((item, k) => {
                                                    return (
                                                        <Select.Option value={item} key={k}>{item}</Select.Option>
                                                    );
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {this.state.instalmentFrequency !== "custom" && (
                                    <Col span={7}>
                                        <Form.Item label={<span>Fixed EMI Cut-off Date<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("fixed_emi_cut_off_date")} /> </span>} required={true} style={{ margin: "0" }}>
                                            <Select
                                                style={{ width: 200 }}
                                                placeholder="Select Fixed EMI Cut-off Date"
                                                optionFilterProp="children"
                                                onChange={(val) => this.onChange("fixedEMICutOffDate", val)}
                                                className={this.state.instalmentDateCalculation == "1" ? null : "read-only-input"}
                                                disabled={this.state.instalmentDateCalculation == "1" ? false : true}
                                            >
                                                {
                                                    [
                                                        { label: "NA", value: 0 },
                                                        ...(this.state.instalmentFrequency === "custom" ? [] : [{ label: "SM", value: 99 }]),
                                                        ...Array.from({ length: 28 }, (_, i) => ({ label: i + 1, value: i + 1 }))
                                                    ].map((item, k) => (
                                                        <Select.Option value={item.value} key={k}>{item.label}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row> : null}
                            {/* <Row>
                            <Col span={7}>
                                    <Form.Item label={<span>Buyer Subvention Days</span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber min={0} precision={0} value={this.state.buyer_subvention_days} style={{ width: "90%" }} onChange={(val) => this.onChange("buyer_subvention_days", val)} />
                                    </Form.Item>

                                   
                                </Col>
                                <Col span={7}>
                                    <Form.Item label={<span>Seller Subvention Days</span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber precision={3} min={0} value={this.state.seller_subvention_days} style={{ width: "90%" }} onChange={(val) => this.onChange("seller_subvention_days", val)} />
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item label={<span>Subvention Percentage</span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber value={((this.state.normalRoi/365) * this.state.seller_subvention_days).toFixed(3)} style={{ width: "90%" }} disabled />
                                    </Form.Item>
                                </Col>
                            </Row> */}
                            </>
                        }

                        <Row>
                            <Col span={7}>
                                <Form.Item label={<span>Subvention Applicable</span>} required={true} className="w-90 m-0">
                                    <Radio.Group
                                        value={this.state.subvention_program_type}
                                        onChange={(e) => this.onChange("subvention_program_type", e.target.value)}>
                                        <Radio.Button value={1}>Yes</Radio.Button>
                                        <Radio.Button value={0}>No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Subvention Type</span>} required={true} style={{ margin: "0" }}>
                                    <Select
                                        disabled={this.state.subvention_program_type == 0}
                                        style={{ width: 200 }}
                                        placeholder="Select Type"
                                        optionFilterProp="children"
                                        value={this.state.subvention_sub_program_type}
                                        onChange={(val) => this.onChange( "subvention_sub_program_type", val )}
                                    >
                                        {
                                            SubventionType.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.value} key={k}>{item.label}</Select.Option>
                                                );
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item
                                    label={<span>Subvention Percentage</span>} required={true} style={{ margin: "0" }}
                                >
                                    <InputNumber
                                        disabled={this.state.subvention_program_type == 0}
                                        value={this.state.upfront_interest_percentage}
                                        style={{ width: "90%" }} onChange={(val) => this.setState({
                                            upfront_interest_percentage: val
                                        })} />
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item
                                    label={<span>Subvention Days</span>} required={true} style={{ margin: "0" }}
                                >
                                    <InputNumber
                                        min={0}
                                        disabled={this.state.subvention_program_type == 0 || this.state.subvention_sub_program_type == 2}
                                        value={this.state.buyer_subvention_days}
                                        style={{ width: "90%" }} 
                                        onChange={(val) => this.setState({
                                            buyer_subvention_days: val < 0 ? 0 : val
                                        })} />
                                </Form.Item>
                                {this.state.subvention_program_type == 1 && this.state.subvention_sub_program_type == 1 && this.state.buyer_subvention_days== 0  && <p>NA</p>}
                            </Col>
                            </Row>

                        {/* {this.state.normalRoi && (![null , 0 ].includes(this.state.buyer_subvention_days) || ![null , 0 ].includes(this.state.seller_subvention_days))  && <Row className={"text-center mt-10"}>
                            <Col span={8}>
                                From Day: 1
                            </Col>
                            <Col span={8}>
                                To Day: {this.state.buyer_subvention_days}
                            </Col>
                            <Col span={8}>
                                ROI: {
                                ((this.state.normalRoi * this.state.seller_subvention_days)/(this.state.buyer_subvention_days)).toFixed(4)
                                }
                            </Col>
                        </Row>}
                        {this.state.normalRoi && this.state.buyer_subvention_days  != null && this.state.seller_subvention_days != null && <Row className={"text-center mt-10"}>
                            <Col span={8}>
                                From Day: {this.state.buyer_subvention_days + 1}
                            </Col>
                            <Col span={8}>
                                To Day: 9999
                            </Col>
                            <Col span={8}>
                                ROI: {this.state.normalRoi}
                            </Col>
                        </Row>} */}
                        <Row>
                             {this.state.subvention_program_type == 1 && this.state.subvention_sub_program_type == 2 && this.state.interestType != 2 && <p>Full Subvention can only be created with Interest Type Reducing </p>} 
                        </Row>
                        <Row style={{ marginTop: "30px" }}>
                            {
                                this.state.show_api_err ? <Col className={"m-5"}>
                                    <span className={"error-text"}>* {this.state.non_field_error}</span>
                                </Col> : null
                            }
                            <Col span={7}>
                                <Button disabled={this.checkSubmit()} onClick={() => this.onSchemeAddClick()} loading={this.state.loading} className={"ant-btn ant-btn-primary"}>Submit</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row >
        );
    }
}

AddTermLoanSchemeDetail.propTypes = {
    form: PropTypes.object,
    companyId: PropTypes.string,
    isDefaultScheme: PropTypes.bool,
    isLendingScheme: PropTypes.bool,
    clearState: PropTypes.bool,
    stateCleared: PropTypes.func,
    partnerbank: PropTypes.array,
    onSuccess: PropTypes.func,
    schemeType: PropTypes.string,
    schemeTypeData: PropTypes.string,
    anchorList: PropTypes.array
};

export default Form.create({})(AddTermLoanSchemeDetail);